var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.28 595.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ade301;}.cls-2{fill:#353a0a;}.cls-3{fill:#a1e340;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.79,456.81v36.56H89.17v-8.93c0-8.67.32-12.95.26-12.95h-.05s-3,5-3.29,5.53l-4.28,7.31H77.27L73,477c-.31-.52-3.23-5.53-3.29-5.53h0s.26,4.28.26,12.95v8.93H61.29V456.81h8.25l6.84,11.07c2.66,4.34,3.08,5.28,3.13,5.28h0c.06,0,.47-.94,3.14-5.28l6.84-11.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.56,456.08a19,19,0,1,1-18.95,19A18.68,18.68,0,0,1,153.56,456.08Zm0,29.35c6,0,9.87-4.23,9.87-10.34s-3.91-10.34-9.87-10.34-9.81,4.18-9.81,10.34S147.66,485.43,153.56,485.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.27,456.81c6.52,0,11.07,4.34,11.07,9.66a7.87,7.87,0,0,1-4.55,7.16v.05a9.55,9.55,0,0,1,6.43,8.62c0,6.1-4,11.07-13.06,11.07H209.39V456.81Zm-1.83,14.26c2.35,0,4.07-1.47,4.07-3.45s-1.72-3.45-4.07-3.45h-5.28v6.9Zm.83,14.93c2.93,0,4.76-1.72,4.76-4.12,0-2.56-2-4.13-4.76-4.13h-6.11V486Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.19,493.37V456.81H284v36.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.5,485.17v8.2H323.45V456.81h8.77v28.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M386,493.37V456.81h8.77v36.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M461.52,456.81V465H450.4v28.36h-8.78V465h-11v-8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M532.7,456.81l-14,20.37v16.19H510V477.18l-14-20.37h9.82l6.63,9.77a31.56,31.56,0,0,0,1.88,2.66h0a31.56,31.56,0,0,0,1.88-2.66l6.63-9.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M341.42,276.74l.52-.75H305.28l-23,34.23c-1.08,1.73-3.12,5.39-4.93,8.62-1.22,2.2-2.48,4.45-3,5.32-.6-1-2.13-3.62-3.5-6-1.71-3-3.64-6.32-4.65-7.94l-23-34.22H206.81l49.13,72.51-52.09,76.33h36.24L263.9,391c1.32-2,4.1-6.61,6.56-10.69,1.62-2.69,3.29-5.47,3.91-6.43.58.92,2.07,3.44,3.51,5.9,2.39,4.07,5.37,9.15,6.77,11.23l23.8,33.8h36.24L292.6,348.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "366.1 424.83 396.44 394.32 396.44 275.99 366.1 275.99 366.1 424.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.42 361.66 181.42 334.92 91.83 334.92 91.83 304.42 181.42 304.42 181.42 275.99 95.36 275.99 61.5 309.85 61.5 424.83 181.42 424.83 181.42 396.4 91.83 396.4 91.83 361.66 181.42 361.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M486,336.43c-1.87-.64-3.73-1.26-5.56-1.87-15.77-5.25-29.39-9.78-29.39-20.07,0-8.79,8.93-14.93,21.7-14.93,11.88,0,25.42,6.8,28.89,22l.09.38,22.78-22.79C514.33,283.11,495.79,273,474.45,273c-30.6,0-54.56,19-54.56,43.15,0,27.26,24.92,36.27,39.82,41.65,3.44,1.22,6.86,2.33,10.17,3.41,17,5.55,30.49,9.94,30.49,22.12,0,10.49-9.26,17.26-23.6,17.26-18.55,0-29.89-12.75-32.9-25.4l-.1-.41-22.95,22.95c10.91,19.27,30.16,30,54.69,30,33.62,0,57.1-18.79,57.1-45.7C532.61,355.94,509.05,344.33,486,336.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "274 114.87 261.21 127.69 352.65 127.69 365.44 114.87 274 114.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "231.81 213.19 323.25 213.19 336.04 200.37 244.6 200.37 231.81 213.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "288.33 157.7 275.54 170.52 309.1 170.52 321.89 157.7 288.33 157.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExis);
export default __webpack_public_path__ + "static/media/exis.4ef7261212823d1cab034f58ea624738.svg";
export { ForwardRef as ReactComponent };